export const FIRM_DOCUMENT_FOLDER_EDIT_DIALOG_TEST_IDS = {
  cancelButton: 'firm-document-folder-edit-dialog-cancel',
  closeButton: 'firm-document-folder-edit-dialog-close',
  dialog: 'firm-document-folder-edit-dialog',
  folderNameInput: 'firm-document-folder-edit-dialog-name',
  parentFolderMenu: 'firm-document-folder-edit-dialog-parent-menu',
  parentFolderSearch: 'firm-document-folder-edit-dialog-parent-search',
  parentFolderSelect: 'firm-document-folder-edit-dialog-parent-select',
  parentOption: (id: number | null) => `firm-document-folder-edit-dialog-parent-${id ?? 'root'}`,
  saveButton: 'firm-document-folder-edit-dialog-save',
} as const;
